<template>
  <div class="page-footer center-block">
    <span :class="[mobileDisplay ? 'col-block' : 'row-block']">
      <span>{{ $t('LAYOUT.pageFooter.___compassBioinformatics') + (!mobileDisplay ? ' |' : '') + ' ' }}</span>
      <a class="link" href="mailto:service@compassbioinfo.com">service@compassbioinfo.com</a>
    </span>
  </div>
</template>

<script>
import responsitiveData from '@/mixins/responsitiveData.vue'

export default {
  mixins: [
    responsitiveData
  ],
  props: {
    needRWD: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    mobileDisplay () {
      return false
    }
  }
}
</script>
